import React from 'react';
import type { ColDef, EditableCallbackParams } from 'ag-grid-community';
import { LopCrudPage } from '../../components/LopCrudPage';
import { getInventoryRowTypes, saveBatchInventoryRowTypes } from '../../api/inventoryRowTypes';
import type { InventoryRowType } from '../../types/InventoryRowType';
import { t } from '../../i18n/t';

const columnDefs: ColDef<InventoryRowType>[] = [
  {
    field: 'inventoryRowTypeId',
    headerName: t('inventoryRowTypes.columns.inventoryRowTypeId'),
    width: 140,
    cellDataType: 'number',
    editable: (params: EditableCallbackParams<InventoryRowType>) =>
      (params.data as { __status?: string } | undefined)?.__status === 'added',
    sort: 'asc',
  },
  { field: 'inventoryRowTypeName', headerName: t('inventoryRowTypes.columns.inventoryRowTypeName'), flex: 1, editable: true },
];

const newRowDefaults = (): Partial<InventoryRowType> => ({ inventoryRowTypeId: 0, inventoryRowTypeName: '' });

export function InventoryRowTypesPage() {
  return (
    <LopCrudPage<InventoryRowType>
      resourceCode="inventoryRowTypes"
      titleKey="inventoryRowTypes.pageTitle"
      idField="inventoryRowTypeId"
      getRows={getInventoryRowTypes}
      saveBatch={(added, modified, deletedIds) => saveBatchInventoryRowTypes(added, modified, deletedIds as number[])}
      columnDefs={columnDefs}
      newRowDefaults={newRowDefaults}
    />
  );
}
